import { BackendModule, ReadCallback, Services } from 'i18next';
import { ajax } from '../../../common/ajax';

/*
i18next by default uses i18next-http-backend which makes unauthenticated HTTP requests to load translation files. 
We needed to create a custom backend that uses authenticated ajax instance.
*/

interface AuthenticatedHttpBackendOptions {
  loadPath: string;
  crossDomain?: boolean;
}

export class AuthenticatedHttpBackend
  implements BackendModule<AuthenticatedHttpBackendOptions>
{
  static type = 'backend' as const;
  type = 'backend' as const;
  services!: Services;
  options!: AuthenticatedHttpBackendOptions;

  init(services: Services, backendOptions: AuthenticatedHttpBackendOptions) {
    this.services = services;
    this.options = backendOptions;
  }

  async read(language: string, namespace: string, callback: ReadCallback) {
    try {
      const url = this.options.loadPath;

      const response = await ajax.get(url);

      if (response.hasErrors) {
        callback(new Error('Failed to load translations'), null);
      } else {
        callback(null, response.data);
      }
    } catch (error) {
      callback(error as Error, null);
    }
  }
}
